function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCrown = function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18552",
    d: "m145.739 1644.817 5.5 4.482 5.5-4.482 5.5 4.482 5.5-4.482v22h-22z",
    transform: "translate(-145.739 -1644.817)",
    style: {
      fill: "currentColor"
    }
  }));
};

export default SvgCrown;